import React, { ReactNode } from "react";
import cn from "classnames";
import s from "./Segments.module.scss";
import c from "../../styles/container.module.scss";
import bs from "../../styles/block.spacing.module.scss";
import BlockIntro from "../Common/BlockIntro";
import BlockBackground from "../Common/BlockBackground";
import {
  AlignmentVariant,
  InnerSpacingVariant,
  OuterSpacingVariant,
  StyleVariant,
} from "../../lib/storyblok/types/shared";
import type { RichTextContent } from "../../lib/storyblok/types/fieldtypes/richText";
import ItemsWrapper from "./components/ItemsWrapper";
import Item from "./components/Item";

type Props = {
  title?: string;
  description?: RichTextContent;
  buttons?: ReactNode;
  style: StyleVariant;
  contentAlignment: AlignmentVariant;
  innerSpacing: InnerSpacingVariant;
  outerSpacing: OuterSpacingVariant;
  inverted?: boolean;
  children?: ReactNode;
};

type CWSType<P, S> = React.FC<P> & S;

const subComponents = { ItemsWrapper, Item };
type SubComponents = typeof subComponents;

const Segments: CWSType<Props, SubComponents> = ({
  title,
  description,
  buttons,
  style,
  contentAlignment,
  outerSpacing,
  innerSpacing,
  inverted,
  children,
}) => {
  return (
    <>
      <section className={cn(s.segments, bs[innerSpacing], bs[outerSpacing])}>
        <BlockBackground style={style} opacity={100} />

        <div className={cn(c.xWide, s.inner)}>
          <BlockIntro
            alignment={contentAlignment}
            title={title}
            description={description}
            buttons={buttons}
            inverted={inverted}
            width={"contained"}
            spaceHorizontal={false}
          />
        </div>

        {children}
      </section>
    </>
  );
};

Segments.ItemsWrapper = ItemsWrapper;
Segments.Item = Item;

export default Segments;
